module.exports = __webpack_public_path__ + "img/FW_Plantsword.888b4d41.png";